module.exports = __webpack_public_path__ + "static/media/open-in-window.498cf3be.svg";